import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { firstValueFrom, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    router: Router,
    protected readonly keycloak: KeycloakService,
    private auth: AuthService
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      console.log(state);
      await this.auth.keycloakLogin(state);
    }

    return this.getUser(state);
  }

  getUser(state: RouterStateSnapshot) {
    //let root = state?.root?.firstChild?.url?.[0]?.path;
    let me$ = this.auth.getMe().pipe(
      /* map(({ ruoli, certificato }) => {
        return this.checkRoles(state, { ruoli, certificato });
      }) */
      map((me) => {
        if (me) {
          return true;
        } else {
          this.auth.logout();
          return false;
        }
      })
    );
    return firstValueFrom(me$);
  }
}
